import { useStyletron } from 'baseui';
import { Grid, Cell, BEHAVIOR, STYLE } from 'baseui/layout-grid';
import {
    DisplayXSmall,
    LabelSmall,
    LabelLarge,
    ParagraphSmall
} from 'baseui/typography';

const GridHeaderCell = ({ header }: any) => {
    const [,theme] = useStyletron()
    return (
        <Cell span={[12, 12, 12]} >
            <LabelLarge marginTop={theme.sizing.scale400}>{header}</LabelLarge>
        </Cell>
    );
}

export default GridHeaderCell;